/* ══════════════════════════════════════════════════════════════════════════
   HJERTELIG · ALBUM — bevegelse
   Felles avdekking for alle Hjerteminner-seksjoner.

   De syv reglene, kort:
     1. Kjør én gang. unobserve umiddelbart.
     2. 620 ms, 14–16 px. Aldri skalering, aldri sprett.
     3. Én easing-kurve, satt i CSS.
     4. Forskjøvet: 80 ms mellom blokker, 70 ms mellom linjer.
     5. Kun opacity og transform. CLS skal være 0.
     6. Alltid en vei ut: uten JS og med reduser-bevegelse står alt.
     7. Ingenting beveger seg uten at leseren gjorde noe.

   .hj-js settes som ALLER FØRSTE handling. All skjuling i CSS henger under
   den, så en leser uten JavaScript ser en hel seksjon, ikke en tom.
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var vilRedusere = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Linjevis deling av overskrifter ──────────────────────────────────────
     Deler en overskrift i én <span class="hj-linje"> per visuelle linje, så
     linjene kan settes på plass etter hverandre i stedet for som én blokk.

     Range.cloneContents() i stedet for å bygge om fra ren tekst, fordi
     overskriftene inneholder <em> — heroens «live på festen» står i rett
     skrift inne i en kursiv overskrift. Deler man på textContent, ryker den.

     Sikkerhetsventil: høyden måles før og etter. Endrer delingen høyden med
     mer enn én piksel, har linjene brutt annerledes enn de gjorde — da
     legges originalen tilbake og overskriften avdekkes som én blokk.
     Bedre en enklere effekt enn et layouthopp. */
  function delILinjer(el) {
    if (!el || el.dataset.hjDelt) return false;
    /* Avmelding. Bildehjulets overskrift har en display:flex-merkelapp inni
       seg, og en flex-boks midt i en tekstlinje lar seg ikke dele meningsfullt
       på linjebokser. Høydevakten nedenfor ville tatt den, men da hadde vi
       bygget om DOM-en og lagt den tilbake for ingenting. */
    if (el.hasAttribute('data-hj-ikke-del')) return false;
    if (!window.Range || !document.createTreeWalker) return false;

    var førHøyde = el.getBoundingClientRect().height;
    if (!førHøyde) return false;
    var original = el.innerHTML;

    var biter = [], g = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false), n;
    while ((n = g.nextNode())) {
      var t = n.textContent, re = /\S+/g, m;
      while ((m = re.exec(t))) biter.push({ node: n, fra: m.index, til: m.index + m[0].length });
    }
    if (biter.length < 2) return false;

    var r = document.createRange(), rader = [], topp = null, rad = null;
    for (var i = 0; i < biter.length; i++) {
      r.setStart(biter[i].node, biter[i].fra);
      r.setEnd(biter[i].node, biter[i].til);
      var y = Math.round(r.getBoundingClientRect().top);
      if (topp === null || Math.abs(y - topp) > 3) { rad = []; rader.push(rad); topp = y; }
      rad.push(biter[i]);
    }
    if (rader.length < 2) return false;      // én linje: ingenting å forskyve

    var brikker = [];
    for (var j = 0; j < rader.length; j++) {
      var f = rader[j][0], s = rader[j][rader[j].length - 1];
      var rr = document.createRange();
      rr.setStart(f.node, f.fra);
      rr.setEnd(s.node, s.til);
      var sp = document.createElement('span');
      sp.className = 'hj-linje';
      sp.style.setProperty('--l', j);
      sp.appendChild(rr.cloneContents());
      brikker.push(sp);
    }

    el.innerHTML = '';
    for (var k = 0; k < brikker.length; k++) {
      if (k > 0) el.appendChild(document.createTextNode(' '));
      el.appendChild(brikker[k]);
    }
    el.classList.add('hj-linjer');
    el.dataset.hjDelt = '1';

    if (Math.abs(el.getBoundingClientRect().height - førHøyde) > 1) {
      el.innerHTML = original;               // brøt annerledes — legg tilbake
      el.classList.remove('hj-linjer');
      delete el.dataset.hjDelt;
      return false;
    }
    return true;
  }

  function delAlle(rot) {
    if (vilRedusere) return;
    var h = rot.querySelectorAll('.hj-h1.hj-inn, .hj-h2.hj-inn');
    for (var i = 0; i < h.length; i++) delILinjer(h[i]);
  }

  function følgMed(rot) {
    var mål = rot.querySelectorAll('.hj-inn');
    if (!mål.length) return;

    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < mål.length; i++) mål[i].classList.add('er-inne');
      return;
    }
    var io = new IntersectionObserver(function (poster) {
      poster.forEach(function (p) {
        if (!p.isIntersecting) return;
        p.target.classList.add('er-inne');
        io.unobserve(p.target);              // kjører én gang, aldri om igjen
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -5% 0px' });
    for (var j = 0; j < mål.length; j++) io.observe(mål[j]);
  }

  function start(rot) {
    if (!rot || rot.dataset.hjKlar) return;
    rot.dataset.hjKlar = '1';
    rot.classList.add('hj-js');              // først, alltid

    /* Delingen må skje FØR observatøren settes opp. Skjer den etterpå, er
       linjene allerede i sluttilstand når de opprettes, og da finnes ingen
       overgang å kjøre — effekten forsvinner uten at noe ser galt ut.

       Og den må skje etter at skriftene er lastet: deles teksten mens
       fallback-fonten står, brytes linjene på feil sted. Ventingen er
       likevel taket på 300 ms — et blankt hero mens en skrift henger er
       verre enn en overskrift som avdekkes som én blokk. */
    var kjørt = false;
    function videre() {
      if (kjørt) return;
      kjørt = true;
      delAlle(rot);
      følgMed(rot);
    }
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(videre);
      setTimeout(videre, 300);
    } else {
      videre();
    }
  }

  function alle() {
    var r = document.querySelectorAll('.hj');
    for (var i = 0; i < r.length; i++) start(r[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alle);
  } else {
    alle();
  }

  // Shopifys temaredigerer bygger seksjoner om uten å laste siden på nytt.
  document.addEventListener('shopify:section:load', function (e) {
    var r = (e.target || document).querySelectorAll('.hj');
    for (var i = 0; i < r.length; i++) start(r[i]);
  });

  window.hjAlbumStart = start;
})();


/* ──────────────────────────────────────────────────────────────────────────
   KLEBRIG KJOEPSKNAPP - reservekobling
   <product-sticky-form> kobler seg opp i connectedCallback og leter etter
   .footer-group. Paa produktsider er footeren ofte ikke parset enda paa det
   tidspunktet, og temaets egen kode avbryter da for godt - knappen dukker
   aldri opp. Her kobler vi iakttakeren opp selv naar dokumentet er ferdig,
   men bare hvis temaet ikke allerede klarte det.

   Hvorfor denne ligger her og ikke i theme.js: theme.js er den kompilerte
   temabunten, og den byttes ut i sin helhet ved hver temaoppdatering. Da
   forsvinner fiksen. hjertelig-album.js er var egen fil og overlever.
   ────────────────────────────────────────────────────────────────────────── */
(function () {
  function kobleOpp(el) {
    if (!el || el.dataset.hjStickyKoblet === "1") return;
    if (el.scopeFrom && el.scopeTo) return;
    if (typeof el.handleIntersection !== "function") return;

    var fra = document.querySelector(".quick-order-list") || document.getElementById(el.getAttribute("form"));
    var til = document.querySelector(".footer-group");
    if (!fra || !til) return;

    el.scopeFrom = fra;
    el.scopeTo = til;

    var io = new IntersectionObserver(function (entries) { el.handleIntersection(entries); });
    io.observe(fra);
    io.observe(til);
    el.dataset.hjStickyKoblet = "1";
  }

  function kjor() {
    document.querySelectorAll("product-sticky-form").forEach(kobleOpp);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", kjor, { once: true });
  } else {
    kjor();
  }
  window.addEventListener("load", kjor);
  document.addEventListener("shopify:section:load", kjor);
})();
